import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setUploadReportError, setLoading } from "../../repository/slice";

function* uploadTestReportWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/excel/quiz-report/" + payload.id);
        if (isError) {
            yield put(setUploadReportError(message));
        } else {
            yield put(setUploadReportError(null));
            const downloadLink = document.createElement("a");
            downloadLink.href = data.url;
            downloadLink.click();
        }
    } catch (error) {
        console.error("uploadTestReportWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* uploadTestReportWatcher() {
    yield takeLatest("@saga/UPLOAD_TEST_REPORT", uploadTestReportWorker);
};
